/* MAC table configurator visual effects (redesign preview theme).
   Effects only: reads the DOM the configurator renders, adds/removes
   presentation classes, and mirrors the price into a mobile bar.
   It never changes configurator state, prices, SKUs or cart calls. */
(function(){
  var root = document.querySelector('.wc[data-welding-configurator]');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEL = '.wc-card,.wc-product,.wc-chip,.wc-swatch';
  var pending = null;

  // 1) Remember which option was just clicked (engine re-renders the list afterwards)
  root.addEventListener('click', function(e){
    var el = e.target.closest && e.target.closest(SEL);
    if (!el || el.disabled) return;
    var step = el.closest('[data-step]');
    pending = { step: step ? step.getAttribute('data-step') : null, action: el.getAttribute('data-action'), value: el.getAttribute('data-value') };
    setTimeout(flash, 30);
  }, true);

  function flash(){
    if (!pending || reduce) { pending = null; return; }
    var q = '[data-step="' + pending.step + '"] ' + '[data-action="' + pending.action + '"][data-value="' + (window.CSS && CSS.escape ? CSS.escape(pending.value || '') : pending.value) + '"]';
    var el = root.querySelector(q);
    pending = null;
    if (!el) return;
    el.style.setProperty('--fx-h', (el.offsetHeight || 140) + 'px');
    el.classList.remove('mac-fx-hit'); void el.offsetWidth; el.classList.add('mac-fx-hit');
    setTimeout(function(){ el.classList.remove('mac-fx-hit'); }, 900);
  }

  // 2) Animate the price readout whenever the engine writes a new price
  var price = root.querySelector('[data-role="price"]');
  var box = price ? price.closest('.wc-price') : null;
  var last = price ? price.textContent.trim() : '';
  if (price && box && 'MutationObserver' in window) {
    new MutationObserver(function(){
      var now = price.textContent.trim();
      if (now === last) return;
      last = now; syncBar();
      if (reduce) return;
      box.classList.remove('mac-fx-tick'); void box.offsetWidth; box.classList.add('mac-fx-tick');
    }).observe(price, { childList: true, characterData: true, subtree: true });
  }

  // 3) Mobile: floating price readout (mirror only) that scrolls to the summary
  var side = root.querySelector('.wc__sidebar');
  var bar = null, sideVisible = true;
  function priceText(){
    if (!price) return '';
    var inc = price.querySelector('.wc-price__inc');
    return (inc ? inc.textContent : price.textContent).replace(/\s+/g,' ').trim();
  }
  function bottomOffset(){
    // sit above any fixed bottom toolbar the theme shows on mobile
    var off = 10, el = document.elementFromPoint(window.innerWidth/2, window.innerHeight-4);
    while (el && el !== document.body) {
      if (el !== bar && !bar.contains(el) && getComputedStyle(el).position === 'fixed') { off = Math.max(off, el.getBoundingClientRect().height + 8); break; }
      el = el.parentElement;
    }
    return off;
  }
  function syncBar(){
    if (!bar) return;
    bar.style.bottom = bottomOffset() + 'px';
    var t = priceText();
    bar.querySelector('.mac-cfx-bar__v').textContent = t;
    bar.classList.toggle('is-on', !!t && t !== '—' && !sideVisible);
  }
  if (side && price && 'IntersectionObserver' in window) {
    bar = document.createElement('div');
    bar.className = 'mac-cfx-bar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="mac-cfx-bar__p"><small>YOUR PRICE</small><span class="mac-cfx-bar__v"></span></div><button type="button" class="mac-cfx-bar__b" tabindex="-1">SUMMARY</button>';
    document.body.appendChild(bar);
    bar.querySelector('button').addEventListener('click', function(){ side.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); });
    new IntersectionObserver(function(entries){
      sideVisible = entries[0].isIntersecting; syncBar();
    }, { threshold: 0.05 }).observe(side);
    syncBar();
  }
})();
